import getAppContainerId from '../dom/getAppContainerId';

const importDynamicTheme = async (themeName: string) => {
  // A bug with eslint forces us to avoid template string in dynamic imports
  // eslint-disable-next-line prefer-template
  const { theme, appLoader, favIconUrl } = await import('../../themes/' + themeName + 'Theme/' + themeName + 'Imports');

  document.getElementById(getAppContainerId()).innerHTML = appLoader;

  const link = document.createElement('link');
  link.rel = 'shortcut icon';
  link.href = favIconUrl;
  document.head.appendChild(link);

  return theme;
};

/**
 * @componentName importDynamicTheme
 */
export default importDynamicTheme;
